<template>
  <div id="app" class="app-root" :class="{ 'mac-os': userAgent.includes('Mac') }">
    <!-- <layout-header></layout-header> -->
    <div class="app-container" :style="{ position: modal.action && !isDialogLoading ? 'relative' : 'relative' }">
      <div class="app-pages">
        <div class="app-background" :class="{ filter: !isMainPage, cover: isMainPage }" :style="{ background: '#eeeeee', backgroundSize: 'cover' }"></div>
        <div class="max-width" v-if="!isMainPage" :style="{ minHeight: minHeight, display: isMainPage ? 'flex' : 'block', 'align-items': 'center' }">
          <div class="view-container">
            <div class="view-field responsitive-color white-white">
              <router-view/>
            </div>
          </div>
          <!-- <div class="view-container other" v-if="$route.name && !['payment'].includes($route.name)">
            <div class="view-field responsitive-color white-white center-block">
              <router-link :to="{ name: 'introduction' }">
                <button class="white-button long-button">
                  <span>了解更多產品資訊</span>
                </button>
              </router-link>
            </div>
          </div> -->
        </div>
        <div class="app-main-container" v-else>
          <router-view :minHeight="minHeight" />
        </div>
        <layout-footer v-if="$route.name && !['payment'].includes($route.name)"></layout-footer>
      </div>
    </div>
    <div class="modal-container">
      <modal v-if="modal.action" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal.width" :height="modal.height" :customStyles="modal.customStyles" @hide="() => {
        modal.callback && modal.callback()
        setModalAction({})
      }">
        <component :is="modal.action" :param="modal.param" @changeModal="(option, param) => {
          modal.callback && modal.callback(param)
          this.setModalAction(option || {})
        }"></component>
      </modal>
    </div>
    <layout-toast></layout-toast>
    <layoutLoading v-if="isLoading"></layoutLoading>
    <layoutUploading v-if="isUploading"></layoutUploading>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getUserToken } from './api'
import layoutHeader from './components/layout/header'
import layoutFooter from './components/layout/footer'
import layoutToast from './components/tool/toast'
import layoutLoading from './components/layout/loading'
import layoutUploading from './components/layout/uploading'
import responsitive from './mixins/responsitive'
import toastMethods from './mixins/toastMethods'
import loginData from './mixins/loginData'
// modals
import modal from './components/dialog/container'
import order from './components/dialog/order'
import toast from './components/dialog/toast'

require('font-awesome-sass-loader')

export default {
  name: 'app',
  components: {
    layoutHeader,
    layoutFooter,
    layoutToast,
    layoutLoading,
    layoutUploading,
    // modals
    modal,
    order,
    toast
  },
  mixins: [
    responsitive,
    loginData,
    toastMethods
  ],
  data () {
    return {
      userAgent: '',
      minHeight: '300px'
    }
  },
  watch: {
    '$route' () {
      const { body } = document
      body.scroll(0, 0)
      setTimeout(() => window.dispatchEvent(new Event('resize')))
    },
    async 'isLogin' (n, o) {
      if (o !== null) {
        this.setLoadingAction(true)
        await this.preFetchDataGuest()
        if (n) {
          await this.preFetchData()
        }
        this.appInitialAction(n)
        this.setLoadingAction(false)
      }
    }
  },
  computed: {
    ...mapGetters([
      'normalPage',
      'userPage',
      'isLogin',
      'isLoading',
      'isDialogLoading',
      'isUploading',
      'modal'
    ]),
    isMainPage () {
      return this.$route.name && ['main', 'payment', ''].includes(this.$route.name)
    }
  },
  created () {
    this.userAgent = navigator.userAgent
    this.setModalAction({})
    this.setLoadingAction(true)
    const validateLogin = () => {
      if (this.$route.name) {
        this.validateLogin()
      } else {
        setTimeout(() => validateLogin(), 100)
      }
    }
    validateLogin()
  },
  beforeMount () {
    const { body } = document
    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let headerHeight = 0
        let footerHeight = !(this.windowWidth < 1199.9) ? 140 : 170
        if (this.$route.name === 'payment') {
          footerHeight = 0
        }
        let height = rect.height - headerHeight - footerHeight
        this.minHeight = height + 'px'
      }
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },
  methods: {
    ...mapActions([
      'appInitialAction',
      'setLoadingAction',
      'setDialogLoadingAction',
      'clearLoadingAction',
      'clearDialogLoadingAction',
      'setModalAction'
      // global
    ]),
    async preFetchDataGuest () {
    },
    async preFetchData () {
    },
    async validateLogin () {
      let userInfo = this.$ls.get('userInfo') || {}
      await this.preFetchDataGuest()
      if (userInfo['access-token']) {
        await this.preFetchData()
        await this.getUserByToken(userInfo)
      } else {
        this.setUserData(null)
        this.appInitialAction(false)
        this.validateRoute(false)
      }
    },
    async getUserByToken (data) {
      try {
        let response = await getUserToken(data)
        let user = response.data.user || { role: {} }
        this.setUserData(response)
        this.appInitialAction(true)
        this.validateRoute(true, user.role.name, user.admin)
      } catch (error) {
        this.setUserData(null)
        this.appInitialAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.errors[0])
        this.validateRoute(false)
      }
    },
    validateRoute (isLogin, role, admin) {
      let array = []
      if (isLogin) {
        switch (role) {
          default: {
            array = _.union(this.userPage, this.normalPage)
          }
        }
      } else {
        array = this.normalPage
      }
      if (admin) {
        array = _.union(array, this.adminPage)
      }
      this.validateRole(isLogin, array)
    },
    validateRole (isLogin, pages) {
      let routeName = this.$route.name
      if (routeName && !_.includes(pages, routeName)) {
        this.addToast('error', isLogin ? '權限不足' : '請先登入')
        this.$router.push({ name: 'main' })
        this.setLoadingAction(false)
      } else {
        this.setLoadingAction(false)
      }
    }
  }
}
</script>

<style lang="sass">
@import sass/style
</style>



// WEBPACK FOOTER //
// src/App.vue